<template>
  <div>
    <div class="">
      <!-- back button -->
      <div>
        <base-button icon type="primary">
          <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>

          <span class="btn-inner--text">Back</span>
        </base-button>
      </div>

      <!-- header -->
      <div class="mt-6">
        <h3 class="font-semibold text-lg">Add Page</h3>
      </div>

      <!-- input -->
      <div class="mt-4">
        <div>
          <label class=" col-form-label form-control-label">Title</label>

          <base-input placeholder="Title"></base-input>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Sub Title</label>

          <base-input placeholder="Sub Title "></base-input>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Description</label>

          <textarea
            class="form-control"
            placeholder="Description"
            id="page-description"
            rows="3"
          ></textarea>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Image Upload</label>

          <b-form>
            <b-form-file
              @change="filesChange"
              placeholder="Select file"
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-form>
        </div>

        <div>
          <label class=" col-form-label form-control-label">Tags</label>

          <base-input placeholder="Tags "></base-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    filesChange() {}
  }
};
</script>
